<template>
     <section class="h-16 bg-white border-t-2  w-100 fixed bottom-0 inset-x-0 z-50 px-4 text-gray-500 flex justify-center " style="box-shadow: 0 0 3px 1px #ffffff">

           <section class="flex items-center h-full  justify-evenly w-full max-w-[1024px]">
               <div class="w-full flex-center cursor-pointer  flex-col" @click="goHome()" :class="route.name === 'home' ? 'text-blue-600' : ''">
                    <font-awesome-icon icon="home" class="h-6 w-6" />
                    <span class="public-text1">صفحه اصلی</span>
        
               </div> 

               <div class="cursor-pointer w-full flex-center h-10 mx-4  flex-col " @click="categoryBtn()" :class="btn  ? 'text-blue-600' : ''">
                    <font-awesome-icon icon="th-large" class="h-6 w-6" />
                    <span class="public-text1">دسته بندی</span>
               </div> 

               <div @click="goCart" class="cursor-pointer  relative w-full flex-center h-10 ml-4 hover:text-gray-800-400 flex-col" :class="route.name === 'cart' ? 'text-blue-600' : ''" >
                    <span>
                         <font-awesome-icon icon="shopping-cart" class="h-6 w-6" />
                   </span>
                   <span class="public-text1-b">سبد خرید</span>
                    <span class="absolute inline-flex items-center justify-center w-[1.125rem] h-[1.125rem] text-xs font-sm text-white bg-red-700 border border-white rounded-full -top-2 letf-[60%] dark:border-blue-200">{{ qtyCart }}</span>
               </div> 

               <div class="cursor-pointer  w-full flex-center h-10  flex-col" @click="goLogin()" :class="{ 'text-blue-600 ': route.matched.some(r => r.name === 'profile') }">
                    <font-awesome-icon icon="user" class="h-6 w-6" />
                   <span v-if="!login" class="public-text1-b">ورود</span>
                   <span v-else class="public-text1-b"> پروفایل </span>
               </div> 
               <div class="absolute bottom-[4rem] w-60 overflow-hidden  bg-white ltr text-gray-500 shadow shadow-sm shadow-sky-500 transition-all duration-300" style="height:calc(100dvh - 4rem ) "   :class="btn ? 'translate-x-0 right-0' : 'translate-x-full right-[-100%]'">
                    <div class="overflow-y-auto z-50" style="height: calc(100vh - 2rem );">
                     <div class="flex items-center text-white justify-between rtl h-10 px-4 public-text bg-gradient-to-l from-indigo-400 to-cyan-400">
                         <div>
                             <span> دسته بندی ها </span>
                         </div>
                        <button @click="categoryBtn" class=" hover:text-gray-200 p-1 rounded-md">
                           <FontAwesomeIcon icon="close"  class="cursor-pointer h-4 w-4"/>

                        </button>
                       </div>

                       <div class="rtl flex " style="height:calc(100% - 2.5rem)">
                         <div class="w-2/4 h-full bg-gray-200 ">
                             <ul class=" public-text text-gray-600 ">
                                  <li class="h-10 rounded  border-b-2 border-gray-300 flex items-center cursor-pointer hover:bg-white gap-2 hover:text-sky-600 overflow-hidden  overflow-hidden pr-2" :class="main1?'bg-white   text-sky-500':'border-l-2 border-t-2'"  @click="funcMain1">
                                   <FontAwesomeIcon icon="shirt" class=""/>
                                    <span>
                                      لباس کار
                                    </span>
                                  </li>
                                  <li class="h-10  border-b-2 border-gray-300 flex items-center cursor-pointer  hover:bg-white gap-2 hover:text-sky-600 overflow-hidden pr-2" :class="main2?'bg-white  text-sky-500':'border-l-2'" @click="funcMain2">
                                   <FontAwesomeIcon icon="helmet-safety" class=""/>
                                  <span>
                                     تجهیزات ایمنی 
                                  </span>
                                  </li>
                                  <!-- <li class="h-8  border-b-2 border-gray-300 flex-center cursor-pointer hover:bg-gray-100 hover:text-sky-600 overflow-hidden  overflow-hidden" :class="main3?'bg-white  text-sky-500':'border-l-2'  " @click="funcMain3"> مد و پوشاک </li> -->
                                 <li class="h-10  border-b-2 border-l-2 border-gray-300 flex items-center cursor-pointer hover:bg-white hover:text-sky-600 overflow-hidden overflow-hidden pr-2" @click="categoryBtn" >
                                   <a href="https://parsinekala.com/blog/" target="_blank" class="flex items-center gap-2 ">
                                    <FontAwesomeIcon icon="newspaper" class=""/>
                                    <span>
                                      مقالات
                                    </span>

                                   </a> </li>
                                 <li class="h-10  border-b-2 border-l-2 border-gray-300 flex items-center cursor-pointer hover:bg-white hover:text-sky-600 overflow-hidden overflow-hidden pr-2" @click="categoryBtn">
                                   <router-link to="/aboutUs" class="flex items-center gap-2 "> 
                                     <FontAwesomeIcon icon="users" class=""/>
                                   <span>
                                    درباره ما
                                   </span>
                                  </router-link> </li>
                                 <li class="h-10  border-b-2 border-l-2 border-gray-300 flex items-center cursor-pointer hover:bg-white hover:text-sky-600 overflow-hidden overflow-hidden pr-2" @click="categoryBtn">
                                    <router-link to="/work-with-us" class="flex items-center gap-2 ">
                                      <FontAwesomeIcon icon="handshake" class=""/>
                                      <span>
                                        همکاری با ما
                                      </span>


                                    </router-link></li>
                                 <li class="h-10 border-b-2 border-l-2 border-gray-300  flex items-center cursor-pointer hover:bg-white hover:text-sky-600 overflow-hidden overflow-hidden pr-2" @click="categoryBtn">
                                     <router-link to="/contactUs" class="flex items-center gap-2 ">
                                        <FontAwesomeIcon icon="phone" class=""/>
                                        <span>
                                          تماس با ما
                                        </span>
                                    </router-link> </li>
                              </ul>
                        </div>

                       <div class="w-2/4 bg-white h-full">
                          <ul class="w-full h-full public-text text-gray-600" v-if="main1">
                               <li  @click="categoryBtn">
                                 <router-link :to="{ name: 'category', params: { name: 'دوتکه-کار' } }" class="h-10 flex px-2 transition-all hover:bg-gray-200  hover:text-sky-500 items-center ">
                                    دوتکه کار
                                 </router-link>
                               </li>
                               <li  @click="categoryBtn"> 
                                 <router-link :to="{ name: 'category', params: { name: 'یکسره-کار' } }" class="h-10 flex px-2 transition-all hover:bg-gray-200  hover:text-sky-500 items-center">
                                    یکسره کار
                                 </router-link>
                               </li>
                               <li  @click="categoryBtn">
                                 <router-link :to="{ name: 'category', params: { name: 'دوبنده-کار' } }" class="h-10 flex px-2 transition-all hover:bg-gray-200  hover:text-sky-500 items-center">
                                    دوبنده کار
                                 </router-link>
                               </li>
                               <li  @click="categoryBtn">
                                 <router-link :to="{ name: 'category', params: { name: 'تیشرت-کار' } }" class="h-10 flex px-2 transition-all hover:bg-gray-200  hover:text-sky-500 items-center">
                                    تیشرت کار
                                 </router-link>
                               </li>
                               <li  @click="categoryBtn">
                                 <router-link :to="{ name: 'category', params: { name: 'جلیقه-کار' } }" class="h-10 flex px-2 transition-all hover:bg-gray-200  hover:text-sky-500 items-center">
                                    جلیقه کار
                                 </router-link>
                               </li>
                               <li  @click="categoryBtn"> 
                                 <router-link :to="{ name: 'category', params: { name: 'شلوار-کار' } }" class="h-10 flex px-2 transition-all hover:bg-gray-200  hover:text-sky-500 items-center">
                                    شلوار کار
                                 </router-link>
                               </li>         
                               <li  @click="categoryBtn"> 
                                 <router-link :to="{ name: 'category', params: { name: 'لباس-کار' } }" class="h-10 flex px-2 transition-all hover:bg-gray-200  hover:text-sky-500 items-center">
                                    لباس کار
                                 </router-link>
                               </li>     
                               <li  @click="categoryBtn">
                                 <router-link :to="{ name: 'category', params: { name: 'بادگیر' } }" class="h-10 flex px-2 transition-all hover:bg-gray-200  hover:text-sky-500 items-center">
                                    بادگیر
                                 </router-link>
                               </li>        
                               <li  @click="categoryBtn"> 
                                 <router-link :to="{ name: 'category', params: { name: 'زنانه' } }" class="h-10 flex px-2 transition-all hover:bg-gray-200  hover:text-sky-500 items-center">
                                    زنانه
                                 </router-link>
                               </li>                    
                          </ul>

                          <ul class="w-full h-full public-text dark:mr-1" v-if="main2">
                           <li  @click="categoryBtn">
                                   <router-link :to="{ name: 'category', params: { name: 'کفش-کار' } }"  class="h-10 flex px-2 transition-all hover:bg-gray-200 cursor-pointer hover:text-sky-500 items-center">
                                    کفش کار
                                   </router-link>
                               </li>
                               <li  @click="categoryBtn">
                                 <router-link :to="{ name: 'category', params: { name: 'تجهیزات-ایمنی' } }"  class="h-10 flex px-2 transition-all hover:bg-gray-200 cursor-pointer hover:text-sky-500 items-center">
                                    سایر
                                  </router-link>
                               </li>             
                          </ul>
                      </div>

                     </div>

                      </div>
                      
               </div>
           </section>
       
   </section>
</template>
<script setup>
   import { computed,ref } from 'vue';

   import { useRouter,useRoute } from 'vue-router';
//   pinia 

     import { useCartStore } from '@/store/cart';

     import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    const card_item=useCartStore();

    const qtyCart = computed(() => card_item.getQtyCartItem);
    
    const btn=ref(false)
    const router=useRouter();
    const route=useRoute();
    const goCart=()=>{
      if(qtyCart.value)
      router.push('/cart')
    }
    const goHome=()=>{
     router.push('/');
   }
   // const emit=defineEmits(['categoryTab'])

  const main1=ref(true);

  const main2=ref(false);

  const main3=ref(false);
  
  import { useAuthStore } from '@/store/useAuth';
  
  const authStore = useAuthStore();
  const login = computed(()=>authStore.getAuth);

  const funcMain1=()=>{
    
     main2.value=false;
     main3.value=false;
    
     main1.value=true;
  }
  const funcMain2=()=>{
    
     main1.value=false;
     main3.value=false;
     main2.value=true;
  }
//   const funcMain3=()=>{
//      main1.value=false;
//      main2.value=false;
     
//      main3.value=true;

//   }
 
     const categoryBtn=()=>{
   //   emit('categoryTab');
     btn.value=!btn.value;
    }

   const goLogin=()=>{
     if(login.value){
          router.push('/profile')
     }else{
          router.push('/user/login');
     }
   }


</script>